module.exports = __webpack_public_path__ + "media/images/flags/GI-397c847c0e07f91bde16c389cfd7ddb4.svg";